import styles from './CircleOutput.module.css';
import type { CircleOutputProps } from './types';

export function CircleOutput({ value, title }: CircleOutputProps) {
    return (
        <div className={styles.root}>
            <div className={styles.circle}>
                <span className={styles.value}>{value}</span>
            </div>
            <span className={styles.title}>{title}</span>
        </div>
    );
}
